module.exports = __webpack_public_path__ + "img/IoTServe1.7b36d6e4.png";